// Global Instructions Rule Applied!
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'
import { MENU_ITEM_KEY_FUNDS } from '../globals.ts'

const REPORT_CONFIG_NAME_FUND_INVESTMENT_DETAIL = 'Fund Investment Detail'

/** `reporting_config.id` for the configurable per-fund Investment Detail table on the Fund Investments tab. */
export function useFundInvestmentDetailReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () =>
      resolveReportIdForMenuItem(
        reportingConfigs,
        menuItems,
        MENU_ITEM_KEY_FUNDS,
        REPORT_CONFIG_NAME_FUND_INVESTMENT_DETAIL
      ),
    [menuItems, reportingConfigs]
  )
}
